<template>
  <div class="loading">
    <van-loading class="load_pic">
    </van-loading>
  </div>
</template>

<script>
export default {
  name: 'LOADING',
  data() {
    return {}
  },
}
</script>

<style scoped>
.loading {
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
}
.load_pic {
  position: fixed;
  left: 50%;
  top: 50%;
  margin: -0.4rem 0 0 -0.4rem;
  display: block;
  width: 0.8rem;
  height: 0.8rem;
  /* background: url('~@/assets/images/loading.gif') no-repeat 0 0; */
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/loading.vue